var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loader',{attrs:{"loading":_vm.loading}}),(!_vm.loading)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.compiledHTML)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }